import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useModal, useModalUpdate }  from "../context/ModalContext";
import { gaButtonClick, gaPDFDownload } from '../../utils/gatags';
import { usePDF } from "../../components/context/PDFContext";

import pdf0 from '../../assets/pdf/Fastfacts_United-States.pdf';
import pdf1 from '../../assets/pdf/Fastfacts_Sweden.pdf';
import pdf2 from '../../assets/pdf/Fastfacts_Denmark.pdf';
import pdf3 from '../../assets/pdf/Fastfacts_United-Kingdom.pdf';
import pdf4 from '../../assets/pdf/Fastfacts_Germany.pdf';
import pdf5 from '../../assets/pdf/Fastfacts_Belgium.pdf';
import pdf6 from '../../assets/pdf/Fastfacts_France.pdf';
import pdf7 from '../../assets/pdf/Fastfacts_Italy.pdf';
import pdf8 from '../../assets/pdf/Fastfacts_Eastern-Europe.pdf';
import pdf9 from '../../assets/pdf/Fastfacts_New-Zealand.pdf';

import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import './PopupModal.css'


const PopupModal = () => {

  

    const pdfarray = [
      pdf0,
      pdf1,
      pdf2,
      pdf3,
      pdf4,
      pdf5,
      pdf6,
      pdf7,
      pdf8,
      pdf9,
    ]

    const PdfIdx = usePDF();
    const modalState = useModal(true);
    const setModalState = useModalUpdate();
    const [isVisible, setIsVisible] = useState(false);

    const toolbarPluginInstance = toolbarPlugin();
    const { Toolbar } = toolbarPluginInstance;

    Modal.setAppElement('#root')


    useEffect(() => {
      // 
    },[]);

    const customStyles = {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 40,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000
        },
        content : {
          position: 'relative',
          background: '#FFFFFF',
          inset: 0,
          margin: 20,
          overflow: 'unset',
          border: "none",
          borderTopRightRadius: 4
        }
      };

      const closeModal = () => {
        setModalState(false);
        setIsVisible(false);
      }

      function afterOpenModal(){
        const url = pdfarray[PdfIdx];
          // Find the last forward slash
        const lastSlashIndex = url.lastIndexOf("/");
        console.log(url.substring(lastSlashIndex + 1) + " -pdf opened");
        // gaButtonClick(
        //   "map-click",
        //   "click",
        //   url.substring(lastSlashIndex + 1) + " -pdf opened"
        // )
      }

      function afterClose(){
        // 
      }

      const downloadPDF = (_e, _action) => {
        const url = pdfarray[PdfIdx];
          // Find the last forward slash
        const lastSlashIndex = url.lastIndexOf("/");
        gaPDFDownload(url.substring(lastSlashIndex + 1));
        _action();
      }


    return (
      <Modal
        closeTimeoutMS={0}
        isOpen={ modalState }
        onAfterOpen={afterOpenModal}
        onAfterClose={afterClose}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        id="react-modal"
        >
              
        <div id="modal-content" className="modal-content">    
          <div id="pdf-view">
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
              <div
                style={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
                }}>

                <div
                  style={{
                  alignItems: 'center',
                  backgroundColor: '#eeeeee',
                  borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '4px',
                  margin: '0px 0px 10px 0px'
                  }}>

                    <Toolbar>
                      {(props) => {
                        const {
                          Download,
                          ZoomIn,
                          ZoomOut,
                        } = props;
                        return (
                          <>
                            <div style={{ padding: '0px 2px' }}>
                              <Download>
                                {(props) => (
                                <button
                                  style={{
                                  width: '34px',
                                  height: '34px',
                                  borderRadius: '34px',
                                  backgroundColor: '#1C59B5',
                                  border: 'none',
                                  color: '#ffffff',
                                  cursor: 'pointer',
                                  padding: '8px 16px',
                                  backgroundImage: `url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cg%3E%3Cpolygon class='st0' points='35,33.8 5.7,33.8 5.7,22.9 8.7,22.9 8.7,30.8 32,30.8 32,22.9 35,22.9 '/%3E%3Cpolygon class='st0' points='22.3,18.4 22.3,7.1 18.3,7.1 18.3,18.4 12.2,18.4 20.3,26.5 28.3,18.4 '/%3E%3C/g%3E%3C/svg%3E%0A")`,
                                  backgroundRepeat: 'no-repeat', 
                                  backgroundSize: '24px',
                                  backgroundPosition: 'center'
                                  }}
                                  onClick={e => downloadPDF(props, props.onClick) }>
                                </button>
                                )}
                              </Download>
                            </div>

                            <div className="zoom-ctrl">                  
                              <div style={{ padding: '0px 2px' }}>
                                <ZoomOut>
                                  {(props) => (
                                  <button
                                    style={{
                                    width: '34px',
                                    height: '34px',
                                    borderRadius: '34px',
                                    backgroundColor: '#1C59B5',
                                    border: 'none',
                                    color: '#ffffff',
                                    cursor: 'pointer',
                                    padding: '8px 16px',
                                    backgroundImage: `url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cpath class='st0' d='M35.8,32.2l-8.9-8.9c1.2-1.9,2-4.1,2-6.5c0-6.6-5.4-11.9-12-11.9s-12,5.4-12,11.9c0,6.6,5.4,11.9,12,11.9 c2.4,0,4.6-0.7,6.5-1.9l8.9,8.9L35.8,32.2z M7.8,16.8c0-4.9,4-8.9,9-8.9s9,4,9,8.9c0,4.9-4,8.9-9,8.9S7.8,21.7,7.8,16.8z'/%3E%3Crect x='10.9' y='15.8' class='st0' width='11.8' height='2'/%3E%3C/svg%3E")`,
                                    backgroundRepeat: 'no-repeat', 
                                    backgroundSize: '24px',
                                    backgroundPosition: 'center'
                                    }}
                                    onClick={props.onClick}>
                                  </button>
                                  )}
                                </ZoomOut>
                              </div>

                              {/* <div style={{ padding: '0px 2px' }}>
                                <CurrentScale>
                                  {(props) => (
                                  <span>{`${Math.round(props.scale * 100)}%`}</span>
                                  )}
                                </CurrentScale>
                              </div> */}

                              <div style={{ padding: '0px 2px' }}>
                                <ZoomIn>
                                  {(props) => (
                                  <button
                                  style={{
                                  width: '34px',
                                  height: '34px',
                                  borderRadius: '34px',
                                  backgroundColor: '#1C59B5',
                                  border: 'none',
                                  color: '#ffffff',
                                  cursor: 'pointer',
                                  padding: '8px 16px',
                                  backgroundImage: `url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cpath class='st0' d='M23.1,4.9c-6.6,0-12,5.4-12,11.9c0,2.4,0.7,4.6,2,6.5l-8.9,8.9l3.5,3.5l8.9-8.9c1.9,1.2,4.1,1.9,6.5,1.9 c6.6,0,12-5.4,12-11.9C35.1,10.2,29.8,4.9,23.1,4.9z M23.1,25.7c-5,0-9-4-9-8.9s4-8.9,9-8.9s9,4,9,8.9S28.1,25.7,23.1,25.7z'/%3E%3Cpolygon class='st0' points='29.1,15.8 24.1,15.8 24.1,10.9 22.1,10.9 22.1,15.8 17.2,15.8 17.2,17.8 22.1,17.8 22.1,22.7 24.1,22.7 24.1,17.8 29.1,17.8 '/%3E%3C/svg%3E")`,
                                  backgroundRepeat: 'no-repeat', 
                                  backgroundSize: '24px',
                                  backgroundPosition: 'center'
                                  }}
                                  onClick={props.onClick}
                                  ></button>
                                  )}
                                </ZoomIn>
                              </div>
                            </div>

                            <div style={{ padding: '0px 2px' }}>   
                              <button
                                style={{
                                width: '34px',
                                height: '34px',
                                backgroundColor: '#1C59B5',
                                border: 'none',
                                color: '#ffffff',
                                cursor: 'pointer',
                                padding: '8px 16px',
                                borderRadius: '34px',
                                backgroundImage: `url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cpolygon class='st0' points='28.1,14.8 28.1,14.8 29.9,13 27.8,10.9 20.3,18.3 14.7,12.7 14.7,12.7 12.9,10.9 10.8,13 18.2,20.5 10.8,27.9 12.9,30 14.6,28.2 14.7,28.2 20.3,22.6 26,28.2 26,28.2 27.8,30 29.9,27.9 22.4,20.5 '/%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat', 
                                backgroundSize: '24px',
                                backgroundPosition: 'center'
                                }}
                                onClick={closeModal}>
                              </button>
                            </div>
                          </>
                        );
                      }}
                    </Toolbar>
                  </div>
                        <div
                        style={{
                        flex: 1,
                        overflow: 'hidden',
                        }}
                        >
                        <Viewer fileUrl={pdfarray[PdfIdx]} plugins={[toolbarPluginInstance]} defaultScale={SpecialZoomLevel.PageFit} />
                </div>
              </div>
                     

            </Worker>
          </div>         
        </div>
              
      </Modal>

    );
};


export default PopupModal;